import React, { useRef, useEffect } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useContent } from "contexts/contentContext/contentContext";

const RecaptchaV3 = ({ callback }) => {
  const recaptchaRef = useRef();
  const { getLanguageCulture, getBasicSettingsData } = useContent();

  const generateToken = async () => {
    await recaptchaRef?.current.executeAsync();
  };

  useEffect(() => {
    generateToken();
  }, [callback]);

  return (
    <ReCAPTCHA
      hl={getLanguageCulture()}
      ref={recaptchaRef}
      size="invisible"
      sitekey={getBasicSettingsData().recaptchaKeyReact}
      onChange={async (token) => callback && (await callback(token))}
    />
  );
};

const RecaptchaV3Memo = React.memo(RecaptchaV3);

export default RecaptchaV3Memo;
